module.exports = __webpack_public_path__ + "static/media/shape-bg.145343ac.png";